module.exports = __webpack_public_path__ + "img/cirle-arrow.8ec66d51.svg";